import { render, staticRenderFns } from "./EditorStyleSettingsModal.vue?vue&type=template&id=f55b2b4e&scoped=true"
import script from "./EditorStyleSettingsModal.vue?vue&type=script&lang=ts"
export * from "./EditorStyleSettingsModal.vue?vue&type=script&lang=ts"
import style0 from "./EditorStyleSettingsModal.vue?vue&type=style&index=0&id=f55b2b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55b2b4e",
  null
  
)

export default component.exports